import _ from 'topmeteo/utils/i18n';

import {getClassName} from './BaseTab';

const Message = _('Track export ist not available for anonymous users.');

const NotAvailable = ({id, active, children}) => (
    <div className={getClassName(id, active)}>
        {children || <p>{Message}</p>}
    </div>
);

export default NotAvailable;
